import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "cars",
        object: "car",
        header: [
            { text: "Patente", value: "patent" },
            { text: "Marca", value: "car_model_id" },
            { text: "Modelo", value: "cars" },
            { text: "Acciones", value: "actions", sortable: false }
        ],
        colors: { 
            without_cars: "primary",
            with_cars: "green",
            with_but_without_verification: "yellow",
            without_verification: "red",
        }
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
